import React, { useState } from 'react';
import DashboardLayout from '../components/DashboardLayout';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Plus, Search, Filter, MapPin, Calendar, TrendingUp } from 'lucide-react';

const Fahrzeuge = () => {
  const [searchTerm, setSearchTerm] = useState('');

  const fahrzeuge = [
    {
      id: 1,
      marke: 'BMW',
      modell: '320d',
      kennzeichen: 'B-XY 1234',
      fin: 'WBA8E9109GK123456',
      erstzulassung: '03.2019',
      kilometer: '85.000 km',
      kunde: 'Max Müller',
      letztesBesichtigung: '15.11.2024'
    },
    {
      id: 2,
      marke: 'Mercedes',
      modell: 'C 220d',
      kennzeichen: 'M-AB 5678',
      fin: 'WDD2050071F123456',
      erstzulassung: '08.2020',
      kilometer: '45.000 km',
      kunde: 'Anna Schmidt',
      letztesBesichtigung: '12.11.2024'
    },
    {
      id: 3,
      marke: 'Audi',
      modell: 'A4 2.0 TDI',
      kennzeichen: 'HH-CD 9012',
      fin: 'WAUZZZ8K9DA123456',
      erstzulassung: '01.2018',
      kilometer: '120.000 km',
      kunde: 'Peter Wagner',
      letztesBesichtigung: '10.11.2024'
    }
  ];

  const filteredFahrzeuge = fahrzeuge.filter(f =>
    f.marke.toLowerCase().includes(searchTerm.toLowerCase()) ||
    f.modell.toLowerCase().includes(searchTerm.toLowerCase()) ||
    f.kennzeichen.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <DashboardLayout>
      <div className="space-y-6">
        {/* Header */}
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-3xl font-bold text-gray-900">Fahrzeuge</h1>
            <p className="text-gray-500 mt-1">Verwalten Sie Ihre Fahrzeugdatenbank</p>
          </div>
          <Button className="bg-gradient-to-r from-blue-500 to-blue-700 hover:from-blue-600 hover:to-blue-800 text-white shadow-lg">
            <Plus className="w-4 h-4 mr-2" />
            Neues Fahrzeug
          </Button>
        </div>

        {/* Search */}
        <Card className="border-0 shadow-lg">
          <CardContent className="p-6">
            <div className="flex items-center space-x-4">
              <div className="relative flex-1">
                <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400" />
                <Input
                  type="text"
                  placeholder="Suche nach Marke, Modell oder Kennzeichen..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="pl-10 h-12 bg-gray-50 border-0 focus:bg-white"
                />
              </div>
              <Button variant="outline" className="h-12">
                <Filter className="w-4 h-4 mr-2" />
                Filter
              </Button>
            </div>
          </CardContent>
        </Card>

        {/* Fahrzeuge Grid */}
        <div className="grid grid-cols-1 gap-6">
          {filteredFahrzeuge.map((fahrzeug) => (
            <Card key={fahrzeug.id} className="border-0 shadow-lg hover:shadow-xl transition-all">
              <CardContent className="p-6">
                <div className="flex items-start justify-between">
                  <div className="flex items-start space-x-4 flex-1">
                    <div className="w-16 h-16 bg-gradient-to-br from-blue-500 to-blue-700 rounded-xl flex items-center justify-center text-white font-bold text-xl shadow-lg">
                      🚗
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-4 gap-6 flex-1">
                      <div>
                        <div className="text-xs text-gray-500 mb-1">Fahrzeug</div>
                        <div className="font-bold text-gray-900 text-lg">{fahrzeug.marke} {fahrzeug.modell}</div>
                        <div className="text-sm text-gray-600 mt-1 font-mono">{fahrzeug.kennzeichen}</div>
                      </div>
                      <div>
                        <div className="text-xs text-gray-500 mb-1">FIN</div>
                        <div className="font-mono text-xs text-gray-700 bg-gray-100 px-2 py-1 rounded">{fahrzeug.fin}</div>
                        <div className="text-xs text-gray-500 mt-2">EZ: {fahrzeug.erstzulassung}</div>
                      </div>
                      <div>
                        <div className="text-xs text-gray-500 mb-1">Laufleistung</div>
                        <div className="flex items-center space-x-2">
                          <TrendingUp className="w-4 h-4 text-blue-600" />
                          <span className="font-semibold text-gray-900">{fahrzeug.kilometer}</span>
                        </div>
                        <div className="text-xs text-gray-500 mt-2">Kunde: {fahrzeug.kunde}</div>
                      </div>
                      <div>
                        <div className="text-xs text-gray-500 mb-1">Letzte Besichtigung</div>
                        <div className="flex items-center space-x-2">
                          <Calendar className="w-4 h-4 text-blue-600" />
                          <span className="font-medium text-gray-900">{fahrzeug.letztesBesichtigung}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <Button variant="outline">Details</Button>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </DashboardLayout>
  );
};

export default Fahrzeuge;